// Site location options. Currently only Denmark; extend as more location
// overlays are added on the backend.
export const SITE_COUNTRIES = ['Denmark'];

export const DEFAULT_SITE_COUNTRY = 'Denmark';
